import { render, staticRenderFns } from "./userTemplate.vue?vue&type=template&id=a6aed552"
import script from "./userTemplate.vue?vue&type=script&lang=js"
export * from "./userTemplate.vue?vue&type=script&lang=js"
import style0 from "./userTemplate.vue?vue&type=style&index=0&id=a6aed552&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports